import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Balances = styled.div`
  text-align: right;
`;

export const BalanceCurrency = styled.div`
  font-weight: bold;
`;
